
import 'bootstrap/dist/css/bootstrap.css';
import GlobalStyle from "./GlobalStyle/style";
import Routes from "./Routes";

const App = () => {
  return (
    <div>
        <GlobalStyle />
        <Routes />
    </div>
  );
};

export default App;
